import CourseProgressAPI from '@/apis/business/student/course-progress-api.js'

export default {
  namespaced: true,

  state: {},

  getters: {},

  mutations: {},

  actions: {
    /**
     * @author VDDung1
     * @description get video progress
     * @param {*} context
     * @param {*} params
     * @returns
     */
    async getCourseProgress (context, params) {
      return await CourseProgressAPI.getAsync(`lesson/${params}`)
    },
    /**
     * @author TTLONG
     * @description get last video
     * @param {*} context
     * @param {*} params
     * @returns
     */
    async getLastVideo (context, params) {
      // return await CourseProgressAPI.getAsync(`video/${params.StudentID}`, params)
      return await CourseProgressAPI.getAsync(`video?studentId=${params.StudentID}&courseId=${params.CourseID ? params.CourseID : ''}`)
    },
    /**
     * @author VDDung1
     * @description cập nhật video progress
     * @param {*} context
     * @param {*} params
     * @returns
     */
    async upsertCourseProgress (context, params) {
      return await CourseProgressAPI.postAsync(
        `lesson/${params.VideoID}`,
        params
      )
    }
  }
}
